import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipOfferingsControllerModule } from './controllers/MembershipOfferingsController';
import { MembershipOfferingsCreateView } from './create/create';

export const MembershipOfferingsView = angular
  .module('acme.view.application.membership.offerings', [
    uiRouter,
    'ui.bootstrap',
    MembershipOfferingsControllerModule,
    MembershipOfferingsCreateView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.offerings',
      url: '/:categoryId/offerings',
      views: {
        'subview-main': {
          controller: 'MembershipOfferingsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/offerings/offerings.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Offerings',
        enablePreferences: true,
      },
    });
  }).name;
